import BlockFactory from '../blocks/BlockFactory';
import Block from '../blocks/Block';

function getTestBlockData() {
	const imageUrl = "https://th.bing.com/th/id/R.4db8527da09487664f0899b2251b7871?rik=DSKcEP3dYAmWTQ&riu=http%3a%2f%2fs1.picswalls.com%2fwallpapers%2f2014%2f01%2f27%2ffree-desktop-background_071551853_19.jpg&ehk=g3MCxDNWTHD%2bT6bVFTDPNoBQB0%2b9q6qlAzhx03YbekM%3d&risl=&pid=ImgRaw&r=0";

	let blockData = [
		{
			type: 'image',
			name: 'test-block1',
			padding: { top: 20, bottom: 30, left: 50, right: 50 },
			backgroundColor: "black",
			data: `<img src="${imageUrl}" style="width:100%;object-fit:contain;"></img>`
		},
		{
			type: 'text',
			name: 'test-block2',
			padding: { top: 50, bottom: 50, left: 50, right: 50 },
			backgroundColor: "white",
			data: {"ops":[{"insert":"The three greatest things you learn from traveling"},{"attributes":{"header":2},"insert":"\n"},{"insert":"Like all the great things on earth traveling teaches us by example. Here are some of the most precious lessons I’ve learned over the years of traveling. Leaving your comfort zone might lead you to such beautiful sceneries like this one.\n"},{"attributes":{"header":3},"insert":"\n"},{"insert":"Appreciation of diversity"},{"attributes":{"header":3},"insert":"\n"},{"insert":"Getting used to an entirely different culture can be challenging. While it’s also nice to learn about cultures online or from books, nothing comes close to experiencing cultural diversity in person. You learn to appreciate each and every single one of the differences while you become more culturally fluid.\nThe real voyage of discovery consists not in seeking new landscapes, but having new eyes."},{"attributes":{"blockquote":true},"insert":"\n"},{"attributes":{"bold":true},"insert":"Marcel Proust"},{"attributes":{"blockquote":true},"insert":"\n"},{"attributes":{"header":3},"insert":"\n"},{"insert":"Improvisation"},{"attributes":{"header":3},"insert":"\n"},{"insert":"Life doesn't allow us to execute every single plan perfectly. This especially seems to be the case when you travel. You plan it down to every minute with a big checklist; but when it comes to executing it, something always comes up and you’re left with your improvising skills. You learn to adapt as you go. Here’s how my travel checklist looks now:\nbuy the ticket "},{"attributes":{"list":"bullet"},"insert":"\n"},{"insert": "start your adventure "},{"attributes":{"list":"bullet"},"insert":"\n"},{"attributes":{"header":3},"insert":"\n"},{"insert":"Confidence"},{"attributes":{"header":3},"insert":"\n"},{"insert":"Going to a new place can be quite terrifying. While change and uncertainty makes us scared, traveling teaches us how ridiculous it is to be afraid of something before it happens. The moment you face your fear and see there was nothing to be afraid of, is the moment you discover bliss.\n"}]}
		},
	];

	return blockData;
}

const EXT_INFO_RESOURCE_NAME = '$extInfo';

class Content {
	constructor() {
		this.clear();
	}

	clear() {
		this.identityId = undefined;
		this.backgroundColor = '';
		this.blocks = [];
		this.isDirty = false;
	}

	async setBackgroundColor(color, saveFlag) {
		console.log("Content.setBackgroundColor: color = " + JSON.stringify(color) +
			", saveFlag = " + saveFlag);

		this.backgroundColor = color;
		this.isDirty = true;

		if (saveFlag) await this.save();
	}

	async setAcl(acl, saveFlag) {
		console.log("Content.setAcl: acl = " + JSON.stringify(acl) +
			", saveFlag = " + saveFlag);

		this.acl = acl;
		this.isDirty = true;

		if (saveFlag) await this.save();
	}

	async addBlock(block, saveFlag) {
		console.log("Content.addBlock: block = " + JSON.stringify(block) +
			", saveFlag = " + saveFlag);

		this.blocks.push(block);
		this.isDirty = true;

		if (saveFlag) await this.save();
	}

	async deleteBlock(block, saveFlag) {
		console.log("Content.deleteBlock: block = " + JSON.stringify(block) +
			", saveFlag = " + saveFlag);

		for (let i = 0; i < this.blocks.length; i++) {
			if (this.blocks[i].name === block.name) {
				this.blocks.splice(i, 1);
				break;
			}
		}
		this.isDirty = true;

		if (saveFlag) await this.save();
	}

	async updateBlock(block, saveFlag) {
		console.log("Content.updateBlock: block = " + JSON.stringify(block) +
			", saveFlag = " + saveFlag);

		for (let i = 0; i < this.blocks.length; i++) {
			if (this.blocks[i].name === block.name) {
				this.blocks[i] = block;
				break;
			}
		}
		this.isDirty = true;

		if (saveFlag) await this.save();
	}

	normalizeResources(resourcesObj) {
		let normalized = {};
		let keys = Object.keys(resourcesObj);

		for (let i = 0; i < keys.length; i++) {
			let k = keys[i];
			normalized[k] = resourcesObj[k].map(e => e.resourceId);
		}
		return normalized;
	}

	async loadFromTemplate(templateId) {
		console.log("loadFromTemplate: templateId = " + JSON.stringify(templateId));

		let result = await global.dipClient.accessIdentity({ app: templateId });
		if (result && result.result === 'OK') {
			this.backgroundColor = result.dattrs.backgroundColor;
			this.blocks = await this.convertFromDipBlocks(result.dattrs.blocks,
				this.normalizeResources(result.resources));

			return true;
		}
		return false;
	}

	getCategory() {
		if (this.isTemplate) {
			return '/ontag/template';
		}
		else {	// category === 'content'
			return '/ontag/content/blocks';
		}
	}

	async preload(category, templateId, blockType) {
		console.log("Content.preload: category = " + category + ", templateId = " + templateId +
			", blockType = " + blockType);

		if (category === 'template') {
			this.isTemplate = true;
		}
		else {	// category === 'content'
			this.isTemplate = false;
		}
	
		if (templateId) {
			await this.loadFromTemplate(templateId);
		}
		else if (blockType) {
			this.blocks = [
				BlockFactory.createEmpty(
					blockType,
					blockType + '-1'	// blockName
				)
			];
		}
	}

	async convertToDipBlocks(blocks, resources) {
		let converted = [];
		for (let i = 0; i < blocks.length; i++) {
			converted.push(await BlockFactory.toDipBlock(blocks[i], resources));
		}
		return converted;
	}

	async convertFromDipBlocks(blocks, resources) {
		let converted = [];
		for (let i = 0; i < blocks.length; i++) {
			converted.push(await BlockFactory.fromDipBlock(blocks[i], resources));
		}

		// Temporary code for testing new type of block
/*
		let blockType = Block.TYPE_CONTACT;
		let blockName = BlockFactory.getDisplayBlockTypeName(blockType) + "1";
		let block = BlockFactory.createEmpty(blockType, blockName);

		let mailUrl = "mailto:madincom@exaxdx.com";
		let mobileUrl = "tel:+8210-9002-0552";
		let homepageUrl = "https://www.ontag.co.kr";

		let titleText = "[ 연락처 ]";
		let mailText = "메일쓰기";
		let mobileText = "전화하기";
		let homepageText = "홈페이지";

		let titleStyle = "font-weight:bold;margin-top:15px;margin-bottom:15px;";
		let itemGroupStyle = "margin-bottom:15px;display:flex;flex-direction:column;align-items:center;";
		let itemDivStyle = "margin-bottom:10px;display:flex;";
		let itemStartIconStyle = "width:15px;height:15px;margin-right:10px;"
		let itemTextStyle = "font-weight:bold;";

		let itemStartIcon = "icons/drawable-xhdpi/설정_아이콘.png";

		block.backgroundColor = "lightyellow";

		block.data =
			`<div style="display:flex;flex-direction:column;align-items:center;">` +
				`<p style="${titleStyle}">${titleText}</p>` +
				`<div style="${itemGroupStyle}">` +
					`<div style="${itemDivStyle}">` +
						`<img src="${itemStartIcon}" style="${itemStartIconStyle}" alt="icon"/>` +
						`<p style="${itemTextStyle}">` +
							`<a href="${mobileUrl}">` +
								`${mobileText}` +
							`</a>` +
						`</p>` +
					`</div>` +
					`<div style="${itemDivStyle}">` +
						`<img src="${itemStartIcon}" style="${itemStartIconStyle}" alt="icon"/>` +
						`<p style="${itemTextStyle}">` +
							`<a href="${mailUrl}">` +
								`${mailText}` +
							`</a>` + 
						`</p>` +
					`</div>` +
					`<div style="${itemDivStyle}">` +
						`<img src="${itemStartIcon}" style="${itemStartIconStyle}" alt="icon"/>` +
						`<p style="${itemTextStyle}">` +
							`<a href="${homepageUrl}" target="_blank" rel="noopener noreferrer">` +
								`${homepageText}` +
							`</a>` +
						`</p>` +
					`</div>` +
				`</div>` +
			`</div>`;

		converted.push(block);
*/
		//

		return converted;
	}

	getIdentityIdValue(identityIdObj) {
		if (identityIdObj.id) return identityIdObj.id;
		if (identityIdObj.qr) return identityIdObj.qr;
		if (identityIdObj.app) return identityIdObj.app;
		return undefined;
	}

	async _load(dattrs, resources) {
		this.isTemplate = dattrs.isTemplate;
		this.backgroundColor = dattrs.backgroundColor;
		this.blocks = await this.convertFromDipBlocks(dattrs.blocks, resources);
		this.isTemporary = dattrs.isTemporary;
		this.extInfoResources = resources[EXT_INFO_RESOURCE_NAME];
	}
	
	generateReturnForAccessIdentity(blockReason, isLocked) {
		this.blockReason = blockReason;
		this.isLocked = isLocked;
		return { blockReason, isLocked };
	}

	async invokeAccessIdentity(accessParams) {
		let result = await global.dipClient.accessIdentity(this.identityId, accessParams);
		if (result) {
			if (result.result === 'OK') {
				await this._load(result.dattrs, this.normalizeResources(result.resources));
				return this.generateReturnForAccessIdentity(undefined, undefined);
			}
			else if (result.result === 'PASSWORD_REQUIRED') {
				return this.generateReturnForAccessIdentity(undefined, true);
			}
			else if (result.result === 'PASSWORD_NOT_MATCHED' || result.result === 'ACCESS_LIMIT' ||
				result.result === 'TOO_EARLY' || result.result === 'EXPIRED') {
				return this.generateReturnForAccessIdentity(result.result, undefined);
			}
		}
		return this.generateReturnForAccessIdentity("UNKNOWN", undefined);
	}

	async load(identityIdObj) {
		console.log("Content.load: identityIdObj = " + JSON.stringify(identityIdObj));

		this.identityId = this.getIdentityIdValue(identityIdObj);
		if (this.identityId) {
			let dattrs, resources;
			if (global.dipClient.isAuthInfoValid()) {
				let identities = await global.dipClient.getIdentities([ this.identityId ]);
				if (Array.isArray(identities) && identities.length > 0) {
					// ACL data can be obtained only when authorized with authToken
					this.acl = identities[0].acl;
					await this._load(identities[0].dattrs, identities[0].resources);

					this.blockReason = undefined;
					this.isLocked = undefined;
				}
			}
			else {
				await this.invokeAccessIdentity();
			}
		}

		// TODO: temporary for testing
		//this.blocks = getTestBlockData();
	}

	async unlock(accessParams) {
		return await this.invokeAccessIdentity(accessParams);
	}

	getViewerAppUrl() {
		return `https://content-editor-${process.env.REACT_APP_ENV_KEY}.ontag.co.kr`;
	}

	processExtInfoResources(extInfoResources, resourcesObj) {
		console.log("processExtInfoResources: extInfoResources = " + JSON.stringify(extInfoResources) +
			", resourcesObj = " + JSON.stringify(resourcesObj));

		if (!Array.isArray(extInfoResources)) {
			return;
		}

		resourcesObj[EXT_INFO_RESOURCE_NAME] = [];

		for (let i = 0; i < extInfoResources.length; i++) {
			if (typeof extInfoResources[i] === 'string') {
				resourcesObj[EXT_INFO_RESOURCE_NAME].push(extInfoResources[i]);
			}
		}

		console.log("processExtInfoResources: updated resourcesObj = " + JSON.stringify(resourcesObj));
	}

	async createTemporaryIdentity() {
		let saveType, saveOk;

		try {
			const updaterAppUrl = undefined;
			const viewerAppUrl = this.getViewerAppUrl();

			// creating a new identity
			//
			let resources = {};
			let blocks = await this.convertToDipBlocks(this.blocks, resources);

			this.processExtInfoResources(this.extInfoResources, resources);

			var identityId = await global.dipClient.createIdentity(
				this.getCategory(),							// category
				undefined,									// auxIds
				this.acl,									// acl
				undefined,									// attrs
				{											// dattrs
					isTemplate: this.isTemplate,
					backgroundColor: this.backgroundColor,
					blocks: blocks,
					isTemporary: false,
					extInfo: this.extInfo,
				},
				resources,									// resources
				updaterAppUrl,								// updaterAppUrl
				viewerAppUrl,								// viewerAppUrl
				true,										// isTemporary
				undefined,									// accessNotifyPolicy
				undefined,									// extensions
			);

			return {
				resultCode: 'OK',
				identityId: identityId
			};
		}
		catch (e) {
			console.log("createTemporaryIdentity: exception = " + JSON.stringify(e));
		}

		return {
			resultCode: 'ERROR'
		};
	}

	async save(isTemporary, extInfo, extInfoResources) {
		let saveType, saveOk;

		try {
			this.isTemporary = isTemporary;
			if (extInfo) {
				// if extInfo is not given, just use the existing one
				this.extInfo = extInfo;
			}
			if (extInfoResources) {
				// if extInfoResources is not given, just use the existing one
				this.extInfoResources = extInfoResources;
			}

			let resources = {};
			let blocks = await this.convertToDipBlocks(this.blocks, resources);

			this.processExtInfoResources(this.extInfoResources, resources);

			if (this.identityId) {
				saveType = 'UPDATE';
				// updating existing identity
				//
				let updates = [
					{
						target: 'dattrs.isTemplate',
						value: this.isTemplate
					},
					{
						target: 'dattrs.backgroundColor',
						value: this.backgroundColor
					},
					{
						target: 'dattrs.blocks',
						value: blocks
					},
					{
						target: 'dattrs.isTemporary',
						value: this.isTemporary
					},
					{
						target: 'resources',
						value: resources
					},
				];

				if (this.acl) {
					updates.push({
						target: 'acl.password',
						value: this.acl.password
					});
				}

				if (this.extInfo) {
					updates.push({
						target: 'dattrs.extInfo',
						value: this.extInfo
					});
				}

				saveOk = await global.dipClient.updateIdentity(
					this.identityId, updates
				);
			}
			else {
				saveType = 'NEW';

				const updaterAppUrl = undefined;
				const viewerAppUrl = this.getViewerAppUrl();

				// creating a new identity
				//
				this.identityId = await global.dipClient.createIdentity(
					this.getCategory(),							// category
					undefined,									// auxIds
					this.acl,									// acl
					undefined,									// attrs
					{											// dattrs
						isTemplate: this.isTemplate,
						backgroundColor: this.backgroundColor,
						blocks: blocks,
						isTemporary: this.isTemporary,
						extInfo: this.extInfo,
					},
					resources,									// resources
					updaterAppUrl,								// updaterAppUrl
					viewerAppUrl,								// viewerAppUrl
					false,										// isTemporary
					undefined,									// accessNotifyPolicy
					undefined,									// extensions
				);

				if (this.identityId) saveOk = true;
				else saveOk = false;
			}
			this.isDirty = false;

			if (saveOk) {
				return {
					resultCode: 'OK',
					identityId: this.identityId,
					saveType: saveType,
				};
			}
		}
		catch (e) {
			console.log("save: exception = " + JSON.stringify(e));
		}

		return {
			resultCode: 'ERROR',
			saveType: saveType,
		};
	}

	getStatus() {
		return {
			identityId: this.identityId,
			isTemporary: this.isTemporary,
			isDirty: this.isDirty,
		};
	}
}

export default Content;
